import { render, staticRenderFns } from "./Step2-Type1-Content.vue?vue&type=template&id=a6b4feb2&scoped=true&"
import script from "./Step2-Type1-Content.vue?vue&type=script&lang=js&"
export * from "./Step2-Type1-Content.vue?vue&type=script&lang=js&"
import style0 from "./Step2-Type1-Content.vue?vue&type=style&index=0&id=a6b4feb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b4feb2",
  null
  
)

export default component.exports